import { render, staticRenderFns } from "./quxian.vue?vue&type=template&id=436139bc&scoped=true&"
import script from "./quxian.vue?vue&type=script&lang=js&"
export * from "./quxian.vue?vue&type=script&lang=js&"
import style0 from "./quxian.vue?vue&type=style&index=0&id=436139bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436139bc",
  null
  
)

export default component.exports